const NAME_PATTERN = /^[\p{L}\p{M}\p{N}][\p{L}\p{M}\p{N}\s.'_\-+]*$/u;

const normalizeDisplayName = (name) => String(name || '').trim().replace(/\s+/g, ' ');

const validateDisplayName = (name) => {
  const normalized = normalizeDisplayName(name);
  return normalized.length >= 2 && normalized.length <= 50 && NAME_PATTERN.test(normalized);
};

export { normalizeDisplayName };
export default validateDisplayName;
